import React, { useContext } from 'react';
import ConditionalSelectComponent from '../../../../common/components/ConditionalSelectComponent';
import LoadingComponent from '../../../../common/components/LoadingComponent';
import { Box, Typography } from '@mui/material';
import { WindowSizeContext } from '../../../../common/context/WindowSizeContext';
import { getSelectedOption } from '../../../../common/utils';
import { toast } from 'react-toastify';

export default function NumOfDaysFilter({ filters, onFilterChange, isLoading }) {
    const windowSize = useContext(WindowSizeContext);

    const availableOptions = [
        { value: 3, label: '3 Days' },
        { value: 7, label: '7 Days' },
        { value: 15, label: '15 Days' },
        { value: 30, label: '30 Days' }
    ];

    if (isLoading) {
        return (
            <Box md={2} sx={{ marginY: -1, paddingX: 2, display: 'flex', justifyContent: 'end', width: '100%' }}>
                <LoadingComponent />
            </Box>
        );
    }

    // Controlled value: mobile expects primitive, desktop expects the full option object
    const controlledValue = filters
        ? (windowSize.isOnMobile
            ? filters?.days
            : getSelectedOption(filters?.days, availableOptions))
        : (windowSize.isOnMobile ? '' : null);

    return (
        <>
            <ConditionalSelectComponent
                id="no_of_days_filter"
                labelId="no_of_days_filter-label"
                options={availableOptions}
                label="No of Days"
                value={controlledValue}
                onSelectChange={(event, newValue) => {
                    // Normalize the selected value across mobile/desktop
                    const selectedValue = windowSize.isOnMobile
                        ? Number(event.target.value) // event.target.value is a string => normalize to number
                        : Number(newValue?.value);

                    // Update parent state
                    onFilterChange(selectedValue, 'days');

                    // Show toast only when 15 days is selected
                    if (selectedValue === 15) {
                        toast.info(
                            <Box>
                                <Typography variant="body2" fontSize="small" fontWeight="bold">
                                    No. of Days: 15 Days
                                </Typography>
                                <Typography variant="body2" fontSize="small" sx={{ mt: 0.5 }}>
                                    Includes items with <strong>12–15 zero-sales days</strong> in the <strong>last 15 days, consecutive or non-consecutive</strong>.
                                </Typography>
                            </Box>,
                            {
                                autoClose: false,
                                closeOnClick: true
                            }
                        );
                    }
                }}
                endAdornment={false}
                disableClearable
            />
        </>
    );
}